import React from 'react'
import Navbar from '../Components/Navbar'
import HeroImg from '../Components/HeroImg'
import Footer from '../Components/Footer'
import Work from   "../Components/Work"

function Home() {
  return (
    <div>
        <Navbar />
        <HeroImg />
        <Work />
        <Footer />
    </div>
  )
}

export default Home